/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";
import { $api, initialAuth, arrToObj, notify, $loading } from "@/assets/helper";
import superAdminPages from "@/assets/superadmin";
import clientPages from "@/assets/client";
import manageDriversTicketsOnlyPages from "@/assets/manageDriversTrucks";
const routeState = {
  init: false
};

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue")
        },

        ...superAdminPages
      ]
    },
    // =============================================================================
    // CLIENT PAGES
    // =============================================================================
    {
      path: "/",
      component: () => import("@/layouts/main/Main.vue"),

      children: [
        {
          path: "/me",
          name: "client",
          component: () => import("./views/Client/View.vue"),
          meta: {
            clientOnly: true,
            padding: true,
            requiresAuth: true
          }
        },
        {
          path: "/fund",
          name: "fundrequest",
          component: () => import("./views/Client/Fund.vue"),
          meta: {
            clientOnly: true,
            padding: true,
            requiresAuth: true
          }
        },
        {
          path: "/my-transactions",
          name: "mytransactions",
          component: () => import("./views/Client/Transactions.vue"),
          meta: {
            clientOnly: true,
            padding: true,
            requiresAuth: true
          }
        },
        {
          path: "/client-accounts",
          name: "clientAccounts",
          component: () => import("./views/Client/ClientList.vue"),
          meta: {
            clientOnly: true,
            padding: true,
            requiresAuth: true
          }
        },
        {
          path: "/client-projects",
          name: "clientProjects",
          component: () => import("./views/Client/Projects.vue"),
          meta: {
            clientOnly: true,
            padding: true,
            requiresAuth: true
          }
        },
      ]
    },
    // =============================================================================
    // MANGAGE DRIVERS & TRUCKS ONLY
    // =============================================================================
    // {
    //   path: "/",
    //   component: () => import("@/layouts/main/Main.vue"),

    //   children: [
    //     {
    //       path: "/me",
    //       name: "client",
    //       component: () => import("./views/Client/View.vue"),
    //       meta: {
    //         clientOnly: true,
    //         padding: true,
    //         requiresAuth: true
    //       }
    //     },
    //   ]
    // },

    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),

      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            authPage: true
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            authPage: true
          }
        },
        {
          path: "/pages/reset",
          name: "new-pass",
          component: () => import("@/views/pages/Reset.vue"),
          meta: {
            authPage: true,
            newpass: true
          }
        },
        {
          path: "/pages/forgot",
          name: "new-pass",
          component: () => import("@/views/pages/Forgot.vue"),
          meta: {
            authPage: true,
            newpass: true
          }
        },
        {
          path: "/pages/newacct/:token",
          name: "reset",
          component: () => import("@/views/pages/NewPass.vue"),
          meta: {
            authPage: true
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});
router.beforeEach(async (to, from, next) => {
  store.commit("SET_PROP", { where: ["crumbName"], what: "" });
  console.log("TOOOOOO", to);
  $loading();

  let logged = await initialAuth(to, store);

  let nextRoute = false;

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  let authPage = to.matched.some(record => record.meta.authPage);
  let newpass = to.matched.some(record => record.meta.newpass);

  if (!logged && requiresAuth) {
    console.log("SENDING THEM OUT");
    return next("/pages/login");
  }

  // let productList = to.matched.some(record => record.meta.productList)
  let productView = to.matched.some(record => record.meta.productView);

  // let transactionList = to.matched.some(record => record.meta.transactionList)
  let transactionView = to.matched.some(record => record.meta.transactionView);

  // let accountList = to.matched.some(record => record.meta.accountList)
  let accountView = to.matched.some(record => record.meta.accountView);

  let apiRoute = to.meta.api;
  let apiCount = to.meta.apiCount;
  let stateKey = to.meta.state;

  let adminPage = to.matched.some(record => record.meta.adminPage);
  let superAdminPage = to.matched.some(record => record.meta.superAdminPage);

  if (!logged && !authPage) return next("/pages/login");

  let isClient = store.getters.isClient;
  let isAuth = store.getters.isAuth;
  let isManageTruckDriverOnly = store.getters.isManageTruckDriverOnly;
  let isManageAll = store.getters.isManageAll;
  let isAdmin = store.getters.isAdmin;
  let isSuper = store.getters.isSuper;

  if (requiresAuth && !isAuth) return next("/pages/login");
  else if (authPage && isAuth) {
    if (newpass) {
      return next();
    } else {
      notify({
        time: 4000,
        title: "You are already logged in",
        text: `Cannot goto system pages. Please sign out and try again.`,
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center"
      });

      return next("/");
    }
  }

  if (!requiresAuth) return next();

  if (isClient || isManageTruckDriverOnly || isManageAll) {
    let { data } = await $api.get("/accounts/me");
    // console.log("DATAA", data);
    let accountData;
    if(data.parentId){
      let params = { pId: data.parentId, roleId: data.user.role.id };
      let { data: parentData } = await $api.get(`/accounts/parent`, {
        params
      });
      accountData = parentData
    }
    else{
      accountData = data;
    }
    // console.log("AcocountData", accountData);
    store.commit("SET_PROP", { where: ["currentAccount"], what: accountData });
  }
  if (to.fullPath === "/" && isClient) {
    return next("/me");
  }

  let products = store.state.products;
  let transactions = store.state.transactions;
  let accounts = store.state.accounts;

  let isProducts = Object.keys(store.state.products).length;

  let id = "";
  if (to.params && to.params.id) id = to.params.id;

  if (!isProducts) {
    let { data } = await $api.get("/products");
    store.commit("SET_PROP", {
      where: ["products"],
      what: data,
      a2o: true
    });
  }

  if (apiRoute && stateKey) {
    let { data } = await $api.get(apiRoute);
    store.commit("SET_PROP", { where: [stateKey], what: data, a2o: true });
  }
  if (apiCount && stateKey) {
    let { data } = await $api.get(apiCount);
    store.commit("SET_PROP", { where: ["counts", stateKey], what: data });
  }

  if (productView) {
    if (!id.trim()) return next("/products");

    if (!products[id]) {
      let resp = await $api.get(`/products/${id}`);
      let item = resp.data;
      console.log("PRODUC VIEW", resp);

      if (!item.id) {
        notify({
          title: "Invalid Product Id",
          text: `Cannot find this product.`,
          color: "warning",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "bottom-center"
        });
        return next("/products");
      }

      store.commit("SET_PROP", { where: ["currentProduct"], what: item });
    }
  }

  if (accountView) {
    if (!id.trim()) return next("/accounts");

    let { data: item } = await $api.get(`/accounts/${id}`);
    if (!item.id) {
      notify({
        title: "Invalid Account Id",
        text: `Cannot find this account. Please try another`,
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center"
      });
      return next("/dash");
    }
    if (!item.code) item.code = "";
    console.log("DATA CONTACTS", item.contacts);
    if (!item.contacts) item.contacts = [];
    store.commit("SET_PROP", { where: ["currentAccount"], what: item });
  }

  if (transactionView) {
    if (!id.trim()) return next("/accounts");

    let { data: item } = $api.get(`/transactions/${id}`);

    if (!item.id) {
      notify({
        title: "Invalid Transaction Id",
        text: `Cannot find this Transaction. Please try another`,
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center"
      });
      return next("/dash");
    }

    store.commit("SET_PROP", { where: ["currentTransaction"], what: item });
  }

  if (nextRoute) next(nextRoute);
  else next();
});

router.afterEach(() => {
  $loading.close();
  // Remove initial loading
  // const appLoading = document.getElementById('loading-bg')
  // if (appLoading) {
  //     appLoading.style.display = "none";
  // }
});

export default router;
